import { Styles } from '@monkvision/types';

export const styles: Styles = {
  vehicleOrbitSvg: {
    width: '100%',
    height: 'auto',
  },
};
